import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LoadingScreen from '@hellodarwin/core/lib/components/loading/screen';
import { ProfileInitialState } from '@hellodarwin/core/lib/features/entities';
import useMediaQuery from '@hellodarwin/core/lib/features/helpers/use-media-query';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import AppHeader from './components/AppHeader';
import { AppLayoutContentContainer, GeneralLayout } from './styles';
const AppLayoutV2 = ({ children, isLoading, PageHeader, Navigation, BottomNavigation, naturalScroll, }) => {
    const theme = useTheme();
    const isLaptop = useMediaQuery({ maxWidth: theme.breakpoints.l });
    const isTablet = useMediaQuery({ maxWidth: theme.breakpoints.tablet });
    const isAppLoading = useMemo(() => isLoading, [isLoading]);
    if (isAppLoading) {
        return (_jsxs(GeneralLayout, { "$naturalScroll": naturalScroll, children: [_jsx(AppHeader, { profile: ProfileInitialState, userMenuLinks: [], showMobileUserMenu: true }), _jsx(LoadingScreen, {})] }));
    }
    return (_jsxs(GeneralLayout, { "$naturalScroll": naturalScroll, children: [_jsxs(AppLayoutContentContainer, { hasSider: !isTablet, "$naturalScroll": naturalScroll, children: [Navigation && _jsx(Navigation, {}), _jsxs("div", { style: {
                            overflow: naturalScroll
                                ? 'visible'
                                : isLaptop
                                    ? 'scroll'
                                    : 'hidden',
                            height: naturalScroll ? 'auto' : '100%',
                            width: '100%',
                            flex: '1 1 auto',
                            minHeight: naturalScroll ? '100%' : 0,
                            display: 'flex',
                            flexDirection: 'column',
                        }, children: [PageHeader && _jsx(PageHeader, {}), children] })] }), BottomNavigation && _jsx(BottomNavigation, {})] }));
};
export default AppLayoutV2;
